@if (product) {
<div class="no-wrap">
    <!-- 'from' for configurable or bundle -->
    @if (product.data.is_from_price) {
    <span class="inline-block p1 col-12 m-r-1 va-m"
          translate>from</span>
    }
    <!-- org price for discounted -->
    @if (product.orgPrice) {
    @if (pricePrefix) {
    <span class="c1 col-12 m-r-2">{{pricePrefix}}</span>
    }
    <price class="s1 col-12 inline-block line-through va-m m-r-3"
           [value]="product.orgPrice"></price>
    }
    <!-- final price -->
    <price class="s1 inline-block va-m "
           [value]="product.price"
           [ngClass]="product.orgPrice? 'col-2' : 'col-1'"></price>
    @if(product.data.qty_increments > 1) {
    <div class="p1 inline-block va-m "
         [ngClass]="product.orgPrice? 'col-2' : 'col-1'">&nbsp;each</div>
    }

</div>
@if(setPrice) {
<div class="no-wrap col-12 p1 m-t-2">
    <price class="inline-block va-m "
           [value]="setPrice"></price>
    <div class="inline-block va-m">&nbsp;{{'per ' + ((product.data.qty_increments || 0) === 2 ? 'pair' : 'set')}}</div>
</div>
}
}
